import { Nav } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getAllTranches } from '../../redux/TrancheReducer/action';
import './Tabs.css';

const Tabs = ({ component, activeTab, setActiveTab }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const { trancheSummary, officerPermissions } = useSelector((store) => {
        return {
            trancheSummary:  store.TrancheReducer.tranches,
            officerPermissions: store.UserReducer.officerPermissions
        }
    })

    const dispatch = useDispatch();

    const renderComponentTab = (component) => {
        // if (component === "Tranche") {
        //     return [
        //         { id: 'overview', label: 'Overview' },
        //         { id: 'active', label: 'Active Tranches' },
        //         { id: 'pending', label: 'Pending Tranches' },
        //         { id: 'past', label: 'Past Tranches' },
        //     ];
        // }
        if (component === "TrancheView") {
            return [
                { 
                    id: 'pending-approval', 
                    label: 'Pending for Approval', 
                    count: 0,
                    permissions: {
                        permission_code: "TRANCHE_PENDING_APPROVAL"
                    },
                },
                { 
                    id: 'pending-disbursal', 
                    label: 'Pending for Disbursal', 
                    count: 0,
                    permissions: {
                        permission_code: "TRANCHE_PENDING_DISBURSEMENT"
                    },
                },
                { 
                    id: 'active', 
                    label: 'Active', 
                    count: 0,
                    permissions: {
                        permission_code: "TRANCHE_ACTIVE"
                    },
                },
                { 
                    id: 'closed', 
                    label: 'Closed', 
                    count: 0,
                    permissions: {
                        permission_code: "TRANCHE_CLOSED"
                    },
                },
            ];
        }
        else if (component === "ActiveTrancheView") {
            return [
                { id: 'tranche-details', label: 'Tranche Details'},
                { id: 'disbursal-details', label: 'Disbursal Details'},
                { id: 'payment-history', label: 'Payment History'},
            ];
        }
        else if (component === "ClosedTrancheView") {
            return [
                { id: 'tranche-details', label: 'Tranche Details'},
                { id: 'disbursal-details', label: 'Disbursal Details'},
                { id: 'payment-history', label: 'Payment History'},
            ];
        }
        if (component === "Limit Approved Details") {
            return [
                { 
                    id: 'active', 
                    label: 'Active', 
                    count: 0, 
                    permissions: {
                        permission_code: "APPLICATION_TRANCHE_ACTIVE"
                    },
                },
                { 
                    id: 'closed', 
                    label: 'Closed', 
                    count: 0, 
                    permissions: {
                        permission_code: "APPLICATION_TRANCHE_CLOSED"
                    },
                },
            ];
        }
        if (component === "RolesPermissionsManagement") {
            return [
                // { id: 'users-roles', label: 'Users & Roles' },
                { id: 'roles-permissions', label: 'Roles & Permissions' },
                { id: 'users-permissions', label: 'Users & Permissions'},
            ];
        }

        return [];
    }

    const handleTabSelect = (selectedTab) => {
        if(component === "TrancheView" || component === "ActiveTrancheView" || component === "ClosedTrancheView"){
            setSearchParams({ tab: selectedTab });
        }
        setActiveTab(selectedTab)
    };

   return (
        <div className='w-100'>
            <div className={`border-bottom tabsScrollWrapper`}>
                <Nav
                    variant="tabs"
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                    className="border-0 gap-3"
                >
                    {renderComponentTab(component)
                        .filter(tab => {
                            if (!tab.permissions) return true;
                            return officerPermissions.has(tab.permissions.permission_code);
                        })
                        .map((tab) => (
                        <Nav.Item key={tab.id}>
                            <Nav.Link
                                eventKey={tab.id}
                                // className={`border-0 ${activeTab === tab.id
                                //         ? 'text-primary border-bottom border-2 border-primary fw-semibold'
                                //         : 'text-muted'
                                //     }`}
                                className={`border-0 ${activeTab === tab.id
                                        ? 'text-primary border-bottom border-2 border-primary fw-semibold'
                                        : 'fw-medium'
                                     }`}
                                style={{ fontSize: '1rem', paddingBottom: '0.5rem', color: '#003565' }}
                            >
                                {tab.label}
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>
            </div>
        </div>
    );
};

export default Tabs;